import _defineProperty from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/defineProperty";

var assign = require("lodash/assign");

var reduce = require("lodash/reduce");

var compact = require("lodash/compact");

export function AggsContainer(key, inner) {
  var aggsArray = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  aggsArray = compact(aggsArray);

  if (aggsArray.length > 0) {
    inner.aggs = reduce(aggsArray, assign, {});
  }

  return _defineProperty({}, key, inner);
}